module.exports = __webpack_public_path__ + "img/support.c8f4e5c8.svg";